<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <stockRequest />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import stockRequest from "./components/stockRequest";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "tables",
  components: {
    stockRequest,
    // ProjectsTable,
  },
};
</script>
